angular.module('bmsApp.merrymaids.job')
	.factory('MMJobPartCancelReasonSvc', [
		'CRUDSvc',
		function (CRUDSvc) {

			function options(params) {
				return CRUDSvc.get('api/merrymaids/job-part-cancel-reason/options', params);
			}

			return {
				options: options
			};

		}
	]);